import React, { useState, useEffect } from "react";
import { useAlert } from '../components/AlertModal';
import '../styles/NonStockTaxItemInput.css';

const NonStockTaxItemInput = ({ addToSalesList, taxRate, salesList, setSalesList, input, setInput, openModal, dayOfWeek, formattedDate, formattedTime, setBarcodeFocusEnabled}) => {
    
    const validInput = input && !isNaN(input) && input >= 0;
    const unitPrice = validInput ? input : 5; // 入力が有効ならinput、無効なら5
    const [modalItem, setModalItem] = useState(null);  // モーダルを開くためのアイテムを保持
    const { showAlert } = useAlert();

    const fixedItems = [
    {
        id: 'bag',
        product_name: "レジ袋",
        unit_price: unitPrice,
        quantity: 1,
        category: 8,
        restoreBarcodeFocus: true,
    },
    {
        id: 'prize',
        product_name: "プライズ",
        unit_price: input,
        quantity: 1,
        restoreBarcodeFocus: false,
    },
    {
        id: 'toy',
        product_name: "TOY",
        unit_price: input,
        quantity: 1,
        restoreBarcodeFocus: false,
    },
    {
        id: 'goods',
        product_name: "グッズ",
        unit_price: input,
        quantity: 1,
        restoreBarcodeFocus: false,
    },
    ];
    // salesListが変更されるたびにモーダルを開く
    useEffect(() => {
        if (modalItem) {
        openModal(modalItem);
        setModalItem(null);  // モーダル用アイテムをリセット
        }
    }, [salesList, modalItem, openModal]); // salesListが更新されるたびに実行される


    const handleAddFixedItem = (item) => {
       if (item.id !== 'bag' && (!input || isNaN(input) || input <= 0)) {
            const newItem = {
                    ...item,
                    id: Date.now(), 
                    subtotal: item.unit_price * item.quantity,
                    inventory_fk_id: null, // 在庫管理しないためnull
                    barcode: null, // バーコードなし
                    condition: null, // 商品状態なし
                    set_sale: false, // セット販売ではない
                    discount: 0, // 値引き0
            };
            setSalesList((prevList) => [
                ...prevList,
                newItem                
            ]);
            // モーダルを開く処理はsalesListの更新後に行いたい
            setModalItem(newItem);  // モーダルに渡すアイテムをセット
            setInput("");  // 入力フィールドをリセット 
            }         
        else{   
            setSalesList((prevList) => [
                ...prevList,
                { 
                    ...item,
                    id: Date.now(),  
                    subtotal: item.unit_price * item.quantity,
                    inventory_fk_id: null, // 在庫管理しないためnull
                    barcode: null, // バーコードなし
                    condition: null, // 商品状態なし
                    set_sale: false, // セット販売ではない
                    discount: 0, // 値引き0
                }
            ]);
            setInput(""); // 入力フィールドをリセット
            
        }
    };

    const handleAddItem = (productName) => {
        if (!input || isNaN(input) || input <= 0) {
            showAlert("金額を入力してください");
            return;
        }
     const price = parseFloat(input);
        

        // 内税計算（例：税率10% → 税込み価格の 10/110 を税額として算出）
        const taxAmount = price * (taxRate.tax_rate / (100 + taxRate.tax_rate));  // 税額の計算
        const subtotal = price;  // 入力された金額（内税込み）
        const basePrice = subtotal - taxAmount;  // 税抜価格を計算
        const basePriceWithoutDecimal = Math.floor(basePrice);  // 小数点切り捨て処理

        // 税抜価格を元に再計算
        const basePriceWithoutDecimalwithTax = basePriceWithoutDecimal * (1 + taxRate.tax_rate / 100);
        const basePriceTax = Math.floor(basePriceWithoutDecimalwithTax);  // 税込み価格を計算

        // 1円加算した場合の税込み価格
        const basePriceplusOne = (basePriceWithoutDecimal + 1) * (1 + taxRate.tax_rate / 100);
        const basePriceplusOneWithoutDecimal = Math.floor(basePriceplusOne);  // 小数点切り捨て処理

        let SinbasePrice;  // 税抜価格の最終的な決定値

        // 税込価格が一致しない場合
        if (basePriceTax !== price) {
    
            // 1円加算後の税込み価格も一致しない場合
            if (basePriceplusOneWithoutDecimal !== price) {
                showAlert("分割して下さい");
                return;  // 商品を追加せずに処理を終了

            } else {
                // 1円加算した税抜価格を使用
                SinbasePrice = basePriceWithoutDecimal + 1;
            }
        } else {
            // 税込み価格が一致した場合、税抜価格をそのまま使用
            SinbasePrice = basePriceWithoutDecimal;
        }

        // 新しいアイテムのオブジェクトを作成
        const newItem = {
            product_name: productName,  // 商品名
            unit_price: SinbasePrice,  // 税抜価格を記録
            quantity: 1,  // 数量
            subtotal: SinbasePrice,  // 商品小計（内税）
            inventory_fk_id: null, // 在庫管理なし
            barcode: null, // バーコードなし
            condition: null, // 商品状態なし
            set_sale: false, // セット販売なし
            discount: 0, // 値引き0
            category: 7, // カテゴリー　7　ガチャガチャ
        };

            addToSalesList(newItem);
            setInput(""); // 入力フィールドをリセット
    };

    return (
        <>
        <div className="NonStockTaxItemInput-date">{formattedDate}({dayOfWeek}) {formattedTime}</div>
        <div className="fixed-items-container">
            {fixedItems.map((item) => (
                <button 
                key={item.id} 
                onClick={() => {
                    setBarcodeFocusEnabled(false);

                    handleAddFixedItem(item);

                    if (item.restoreBarcodeFocus) {
                    setTimeout(() => {
                        setBarcodeFocusEnabled(true);
                    }, 0);
                    }
                }}
                className="fixed-item-button"
                >
                <span className="product-name">{item.product_name}</span>
                </button>
            ))}
            <button onClick={() => handleAddItem("ガチャガチャ")} className="fixed-item-button"><span className="product-name">ガチャ</span><span className="product-name">(自動内税)</span></button>
        </div>
        </>
    );
};

export default NonStockTaxItemInput;
